module.exports = {
      id: "icon-premium-usage",
      viewBox: "0 0 40 40",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#icon-premium",
      toString: function () {
        return this.url;
      }
    }